import React, { useRef, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useViewport } from 'hooks/3catinfo/useViewport';
import styles from './modalAfegirContingut.module.scss';
import Boto from 'components/3catinfo/Boto/Boto';
import Icona from '../../ui/Icona/Icona';
import { setStorageValue } from '@portal-internet/core';
import clsx from 'clsx';

const ModalAfegirContingut = ({ onClickClose, onModalScroll, isVisibleModal, isModalSegueix = false, text, tipologia }) => {
    
    const touchStartY = useRef(0);
    const touchEndY = useRef(0);
    const modalContentRef = useRef(null);
    const { zoomNavigator } = useViewport();
    const router = useRouter();
    const modalTopDistance = () =>{
        const element = document.querySelector('[data-testid="menu-boto-usuari-autenticat"]');
        const top = element.getBoundingClientRect().top + element.offsetHeight;
        return top;
    }

    const handleTouchStart = (e) => {
        touchStartY.current = e.targetTouches[0].clientY;
    };

    const handleTouchMove = (e) => {
        touchEndY.current = e.targetTouches[0].clientY;
    };

    const handleOnModalScroll = () => {
        onModalScroll();
    };

    const handleTouchEnd = () => {
        if (touchEndY.current - touchStartY.current > 50) {
            onClickClose();
        }
    };

    const getToday = () => {
        const dateObj = new Date();
        const month = dateObj.getUTCMonth() + 1;
        const day = dateObj.getUTCDate();
        const year = dateObj.getUTCFullYear();
        const hour = dateObj.getUTCHours();
        const min = dateObj.getUTCMinutes();
        const sec = dateObj.getUTCSeconds();
        return year + '/' + month + '/' + day + ' ' + hour + ':'+ min + ':' + sec ;
    };

    const cookieContingutShowed = 'afegirContingutShowed';
    const cookieNoMostrisMes = 'noMostrisMes';
    const handleClickOutside = (e) => {
        if ((modalContentRef.current && modalContentRef.current.contains(e.target))) {
            onClickClose();
            let values = {
                day: getToday()
            }
            setStorageValue(cookieContingutShowed, values, {
                path: '/',
                domain: '.3cat.cat',
                expires: 1
            });
        }
    };

    const handleOnClickNoMostriMes = (e) => {
        setStorageValue(cookieNoMostrisMes, e.target.checked, {
            path: '/',
            domain: '.3cat.cat',
            expires: 30
        });
    };

    const handleClickVesHiAra = () => {
        router.push('/3catinfo/meu3catinfo/');
    };

    const initialFocusRef = useRef(null);

    useEffect(() => {
        // Focus on the element referenced by initialFocusRef
        if (initialFocusRef.current) {
            initialFocusRef.current.focus();
        }
    }, []);

    const stylesWrapper = clsx({
        [styles.modal_wrapper]: true,
        [styles.visible]: isVisibleModal,
        [styles.ambZoom]: zoomNavigator > 3
    });

    return (
        <>
            <div className={styles.outside} onClick={handleClickOutside} onScroll={handleOnModalScroll}>
                &nbsp;
            </div>
            <div className={styles.modal_mask}>
                <div className={styles.modal_container}>
                    <div className={stylesWrapper} style={{top: `${modalTopDistance()}px`}} data-testid="afegircontingut">
                        <div className={styles.modal_content} ref={modalContentRef}>
                            <div
                                onTouchStart={handleTouchStart}
                                onTouchMove={handleTouchMove}
                                onTouchEnd={handleTouchEnd}
                            ></div>
                            <button onClick={handleClickOutside} className={styles.tancar} ref={initialFocusRef} data-testid="tancar_afegircontingut">
                                <Icona className={styles.iconaTancar} icona='tanca' alt='tanca' mida='32' />
                            </button>
                            <div>
                                <div className={styles.text_login_centered}>
                                    <h2 className={styles.modal_titol}>Afegit a ‘El meu 3CatInfo’</h2>
                                    <span className={styles.modal_text}>
                                        Accedeix ràpidament als temes, les firmes i les notícies que segueixes o t&#39;has guardat
                                    </span>
                                    <div className={styles.buttons_login_centered}>
                                        <Boto
                                            tag='button'
                                            text='Ves-hi ara'
                                            estil='ves_hi_ara'
                                            altIcona='Inicia sessió'
                                            dataTestId='areausuaris-ves-hi-ara'
                                            onClick={handleClickVesHiAra}
                                            className={styles.boto}
                                        />
                                        <div>
                                            <input name='noMostrisMesTooltip' id='noMostrisMesTooltip' type='checkbox' onClick={handleOnClickNoMostriMes} />
                                            <label htmlFor='noMostrisMesTooltip'>
                                                No ho mostris més
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ModalAfegirContingut;
